module.exports = __webpack_public_path__ + "img/en_backgroundImg.39e63f1f.jpg";